import { render, staticRenderFns } from "./BankCardEdit.vue?vue&type=template&id=55778560"
import script from "./BankCardEdit.vue?vue&type=script&lang=js"
export * from "./BankCardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports